import React, { Component } from 'react'
import { Icon, Table, Input, Button } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';
import { getCookie } from '../../../hook';

import { get_letter, get_summary } from './../actions/print.action';

// Styles
import './../style.css';

class PaySlip extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data: [],
            summary: [],
            annual_leave_balance: 0,
            allowances: 0,
            tr_allowances: 0,
            basic: 0,
            total_salary: 0
        }

        this.handleCalc = this.handleCalc.bind( this );
        this.handleAllowance = this.handleAllowance.bind( this );
        this.handleTrAllowance = this.handleTrAllowance.bind( this );
        this.handleBasic = this.handleBasic.bind( this );
        this.handlePrintClick = this.handlePrintClick.bind( this );
    }

    handlePrintClick(){
        setTimeout(() => {
            window.print();
        }, 500);
    }

    handleAllowance( e ){
        this.setState({ allowances: e.target.value });
        this.handleCalc();
    }

    handleTrAllowance( e ){
        this.setState({ tr_allowances: e.target.value });
        this.handleCalc();
    }

    handleBasic( e ){
        this.setState({ basic: e.target.value });
        this.handleCalc();
    }

    componentWillMount(){
        this.props.get_letter( this.props.match.params.id );
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.print.length != 0 ){

            if( nextProps.print.STATUS.MESSAGE === "Successfully Listed Annual Leaves Summary" ){

                let leave_summary = nextProps.print.OUTPUT.DATA;

                if( typeof leave_summary.annual_data[0] !== 'undefined' ){

                    if( leave_summary.annual_data[0].date_of_exit !== "0000-00-00" ) {
                        this.setState({
                            summary: leave_summary,
                            annual_leave_balance: leave_summary.annual_data[0].summary[ leave_summary.annual_data[0].summary.length-1 ].unused_leaves
                        });
                    } else {
                        this.setState({
                            summary: leave_summary,
                            annual_leave_balance: leave_summary.annual_data[0].summary[ leave_summary.annual_data[0].summary.length-1 ].unused_leaves
                        });
                    }

                }

                
            }
            
            if( nextProps.print.STATUS.MESSAGE === "Successfully Listed Letter" ){

                let tempData = nextProps.print.OUTPUT.DATA[0];
                this.setState({
                    data: tempData
                });
                this.props.get_summary( tempData.user_id, tempData.request_date );

            }

        }

    }

    convertNumberToWords( amount ) {

        if( isNaN( amount ) === true ){
            return '';
        }

        let dec = amount.toString().split(".");

        var n = dec[0];
        
        var string = n.toString(), units, tens, scales, start, end, chunks, chunksLen, chunk, ints, i, word, words, and = 'and';

        /* Remove spaces and commas */
        string = string.replace(/[, ]/g,"");

        /* Is number zero? */
        if( parseInt( string ) === 0 ) {
            return 'Zero';
        }
        
        /* Array of units as words */
        units = [ '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen' ];
        
        /* Array of tens as words */
        tens = [ '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety' ];
        
        /* Array of scales as words */
        scales = [ '', 'Thousand', 'Million', 'Billion', 'Trillion', 'Quadrillion', 'Quintillion', 'Sextillion', 'Septillion', 'Octillion', 'Nonillion', 'Decillion', 'Undecillion', 'Duodecillion', 'Tredecillion', 'Quatttuor-Decillion', 'Quindecillion', 'Sexdecillion', 'Septen-Decillion', 'Octodecillion', 'Novemdecillion', 'Vigintillion', 'Centillion' ];
        
        /* Split user argument into 3 digit chunks from right to left */
        start = string.length;
        chunks = [];
        while( start > 0 ) {
            end = start;
            chunks.push( string.slice( ( start = Math.max( 0, start - 3 ) ), end ) );
        }
        
        /* Check if function has enough scale words to be able to stringify the user argument */
        chunksLen = chunks.length;
        if( chunksLen > scales.length ) {
            return '';
        }
        
        /* Stringify each integer in each chunk */
        words = [];
        for( i = 0; i < chunksLen; i++ ) {
            
            chunk = parseInt( chunks[i] );
            
            if( chunk ) {
                
                /* Split chunk into array of individual integers */
                ints = chunks[i].split( '' ).reverse().map( parseFloat );
            
                /* If tens integer is 1, i.e. 10, then add 10 to units integer */
                if( ints[1] === 1 ) {
                    ints[0] += 10;
                }
                
                /* Add scale word if chunk is not zero and array item exists */
                if( ( word = scales[i] ) ) {
                    words.push( word );
                }
                
                /* Add unit word if array item exists */
                if( ( word = units[ ints[0] ] ) ) {
                    words.push( word );
                }
                
                /* Add tens word if array item exists */
                if( ( word = tens[ ints[1] ] ) ) {
                    words.push( word );
                }
                
                /* Add 'and' string after units or tens integer if: */
                if( ints[0] || ints[1] ) {
                    
                    /* Chunk has a hundreds integer or chunk is the first of multiple chunks */
                    if( ints[2] || ! i && chunksLen ) {
                        words.push( and );
                    }
                
                }
                
                /* Add hundreds word if array item exists */
                if( ( word = units[ ints[2] ] ) ) {
                    words.push( word + ' Hundred' );
                }
                
            }
            
        }
        
        var words_string =  words.reverse().join( ' ' );

        if( dec[1] !== '00' ){
            return 'Only '+words_string + ' and ' + dec[1] + ' / 100 ';
        } else {
            return 'Only '+words_string;
        }
        
    }

    handleCalc(){

        let self = this;
        setTimeout(()=> {

            let allowances = Math.abs( this.state.allowances );
            let basic = Math.abs( this.state.basic );
            let tr_allowances = Math.abs( this.state.tr_allowances );
    
            let total = allowances+basic+tr_allowances;
    
            self.setState({ total_salary: total });

        }, 500);

    }

    render() {
        return (
            <div className="print_wrapper letter salary_slip">
                
                <table width="100%">

                    <thead>
                        <tr>
                            <th colSpan="2">
                                <span className="print_logo"></span>
                                <span className="jgroup_logo"></span>
                            </th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr>
                            <td  width="80%" valign="top">

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <h1 className="payslip_letter_head">Salary Slip for the Period { this.state.data.start_date } and { this.state.data.end_date }</h1>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td className="fix_height" style={{ backgroundColor: '#f4f4f4',padding: '0 10px',borderBottom: 'solid 1px #666' }}>
                                                <b>Employee Profile</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="auto_height">

                                                <table width="100%" style={{ borderBottom: 'solid 1px #666' }}>
                                                    <tbody>
                                                        <tr>
                                                            <td width="50%" style={{padding: '10px'}} className="auto_height">

                                                                <table width="100%">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td width="40%" className="fix_height">Employee Name<em className="fl_right">:&nbsp;&nbsp;</em></td>
                                                                            <td width="60%" className="fix_height">{ this.state.data.full_name }</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td width="40%" className="fix_height">Designation<em className="fl_right">:&nbsp;&nbsp;</em></td>
                                                                            <td width="60%" className="fix_height">{ this.state.data.designation_name }</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td width="40%" className="fix_height">Department<em className="fl_right">:&nbsp;&nbsp;</em></td>
                                                                            <td width="60%" className="fix_height">{ this.state.data.department_name }</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                
                                                            </td>
                                                            <td width="50%" style={{padding: '10px'}} className="auto_height">
                                                            
                                                                <table width="100%">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td width="40%" className="fix_height">Date of Joining<em className="fl_right">:&nbsp;&nbsp;</em></td>
                                                                            <td width="60%" className="fix_height">{ this.state.data.date_of_joining }</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td width="40%" className="fix_height">Work Location<em className="fl_right">:&nbsp;&nbsp;</em></td>
                                                                            <td width="60%" className="fix_height">{ this.state.data.company_country }</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td width="40%" className="fix_height">Currency<em className="fl_right">:&nbsp;&nbsp;</em></td>
                                                                            <td width="60%" className="fix_height">{ this.state.data.company_currency }</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            
                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td className="fix_height" style={{ backgroundColor: '#f4f4f4',padding: '0 10px'}}>
                                                <b>Salary Profile</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="auto_height">
                                                
                                                <table width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td width="100%" className="auto_height">
                                                                <table width="100%" className="salary_slip_custom_table">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td width="50%" className="fix_height">
                                                                                BASIC
                                                                            </td>
                                                                            <td width="50%" className="fix_height">
                                                                                <Input 
                                                                                    value={ this.state.basic }
                                                                                    onChange={ this.handleBasic }
                                                                                    style={{width: '50%'}} />
                                                                                <span className="fl_right">{ Math.abs( this.state.basic ).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }</span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td width="50%" className="fix_height">
                                                                                Home Allowances
                                                                            </td>
                                                                            <td width="50%" className="fix_height">
                                                                                <Input 
                                                                                    value={ this.state.allowances }
                                                                                    onChange={ this.handleAllowance }
                                                                                    style={{width: '50%'}} />
                                                                                <span className="fl_right">{ Math.abs( this.state.allowances ).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }</span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td width="50%" className="fix_height">
                                                                                Transportation Allowance
                                                                            </td>
                                                                            <td width="50%" className="fix_height">
                                                                                <Input 
                                                                                    value={ this.state.tr_allowances }
                                                                                    onChange={ this.handleTrAllowance }
                                                                                    style={{width: '50%'}} />
                                                                                <span className="fl_right">{ Math.abs( this.state.tr_allowances ).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }</span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td width="50%" className="fix_height">
                                                                                &nbsp;
                                                                            </td>
                                                                            <td width="50%" className="fix_height">
                                                                                <table width="100%">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td width="50%" className="fix_height"><b>Gross Salary</b></td>
                                                                                            <td width="50%" className="fix_height"><span className="fl_right"><b>{ Math.abs( this.state.total_salary ).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }</b></span></td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <td className="fix_height" style={{ backgroundColor: '#f4f4f4',padding: '0 10px'}}>
                                            <b>Actual Salary</b>
                                        </td>
                                        <tr>
                                            <td className="auto_height">

                                                <table width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td width="100%" className="auto_height">
                                                                
                                                                <table width="100%" className="salary_slip_custom_table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th width="25%" colSpan={1}>Element</th>
                                                                            <th width="25%" colSpan={1}>Actual Amount</th>
                                                                            <th width="25%" colSpan={1}>Arrears Amount</th>
                                                                            <th width="25%" colSpan={1}>Total Amount</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td width="25%" colSpan={1}>BASIC</td>
                                                                            <td width="25%" colSpan={1}>{ Math.abs( this.state.basic ).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }</td>
                                                                            <td width="25%" colSpan={1}>0.00</td>
                                                                            <td width="25%" colSpan={1}>{ Math.abs( this.state.basic ).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td width="25%" colSpan={1}>Home Allowances</td>
                                                                            <td width="25%" colSpan={1}>{ Math.abs( this.state.allowances ).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }</td>
                                                                            <td width="25%" colSpan={1}>0.00</td>
                                                                            <td width="25%" colSpan={1}>{ Math.abs( this.state.allowances ).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td width="25%" colSpan={1}>Transportation Allowance</td>
                                                                            <td width="25%" colSpan={1}>{ Math.abs( this.state.tr_allowances ).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }</td>
                                                                            <td width="25%" colSpan={1}>0.00</td>
                                                                            <td width="25%" colSpan={1}>{ Math.abs( this.state.tr_allowances ).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td width="75%" colSpan={3}><b>Total Earnings</b></td>
                                                                            <td width="25%" colSpan={1}><b>{ Math.abs( this.state.total_salary ).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }</b></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td width="75%" colSpan={3}><b>NET Pay</b></td>
                                                                            <td width="25%" colSpan={1}><b>{ Math.abs( this.state.total_salary ).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }</b></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td width="25%" colSpan={1}><b>Amount In Words :</b></td>
                                                                            <td width="75%" colSpan={3}>{ this.convertNumberToWords( Math.abs( this.state.total_salary ).toFixed(2) ) + ' - ' + this.state.data.company_currency }</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>

                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="50%" className="auto_height">
                                                
                                                <table width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td width="100%" className="auto_height">
                                                                <table width="100%" className="salary_slip_custom_table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th width="50%" colSpan={1}>Ticket Type</th>
                                                                            <th width="50%" colSpan={1}>Balance Units</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td width="50%" className="fix_height">
                                                                                Adult
                                                                            </td>
                                                                            <td width="50%" className="fix_height">
                                                                                1.00
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td width="50%" className="fix_height">
                                                                                Child
                                                                            </td>
                                                                            <td width="50%" className="fix_height">
                                                                                0.00
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td width="50%" className="fix_height">
                                                                                Infant
                                                                            </td>
                                                                            <td width="50%" className="fix_height">
                                                                                0.00
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </td>
                                            <td width="50%" className="auto_height" valign="top">

                                                <table width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td width="100%" className="auto_height">
                                                                <table width="100%" className="salary_slip_custom_table">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td width="70%" className="fix_height">
                                                                                <b style={{fontSize: '14px'}}>No.of Paid Days</b>
                                                                            </td>
                                                                            <td width="30%" className="fix_height">
                                                                                { this.state.data.month_count }
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td width="70%">
                                                                                <b style={{fontSize: '14px'}}>No.of Absent days + Leave without pay days</b>
                                                                            </td>
                                                                            <td width="30%" className="fix_height">
                                                                                0.00
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="50%" className="auto_height">

                                                <table width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td width="100%" className="auto_height">
                                                                <table width="100%" className="salary_slip_custom_table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th width="33.33%" colSpan={1}>Leave type</th>
                                                                            <th width="33.33%" colSpan={1}>Balance Days</th>
                                                                            <th width="33.33%" colSpan={1}>Leave Encashment</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td width="33.33%" colSpan={1} className="fix_height">
                                                                                Annual Leave
                                                                            </td>
                                                                            <td width="33.33%" colSpan={1} className="fix_height">
                                                                                <Input 
                                                                                    value={ this.state.annual_leave_balance }
                                                                                    onChange={ (e)=> this.setState({ annual_leave_balance: e.target.value }) }
                                                                                    style={{width: '50%'}} />
                                                                                { this.state.annual_leave_balance }
                                                                            </td>
                                                                            <td width="33.33%" colSpan={1} className="fix_height">
                                                                               
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </td>
                                            <td width="50%" className="auto_height">
                                                &nbsp;
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%"></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">

                                                <table width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td width="100%" className="auto_height">
                                                                <table width="100%" className="salary_slip_custom_table">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td width="50%" colSpan={1} className="auto_height">

                                                                                <table width="100%">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td width="50%" className="fix_height">
                                                                                                <b>Passport Expiry Date</b>
                                                                                            </td>
                                                                                            <td width="50%" className="fix_height">
                                                                                                { this.state.data.passport_expiry }
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                                
                                                                            </td>
                                                                            <td width="50%" colSpan={1} className="auto_height">
                                                                                
                                                                                <table width="100%">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td width="50%" className="fix_height">
                                                                                                <b>Visa Expiry Date</b>
                                                                                            </td>
                                                                                            <td width="50%" className="fix_height">
                                                                                                { this.state.data.visa_expiry_date }
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%"></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" className="auto_height">

                                                <table width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td width="100%" className="auto_height">
                                                                <table width="100%" className="salary_slip_custom_table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th width="25%" colSpan={1}>Bank Name</th>
                                                                            <th width="25%" colSpan={1}>Branch Name</th>
                                                                            <th width="25%" colSpan={1}>Account Number</th>
                                                                            <th width="25%" colSpan={1}>Amount</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td width="25%" colSpan={1} className="fix_height">
                                                                                { this.state.data.bank_name }
                                                                            </td>
                                                                            <td width="25%" colSpan={1} className="fix_height">
                                                                                { this.state.data.bank_address }
                                                                            </td>
                                                                            <td width="25%" colSpan={1} className="fix_height">
                                                                                { this.state.data.bank_acc_number }
                                                                            </td>
                                                                            <td width="25%" colSpan={1} className="fix_height">
                                                                                { Math.abs( this.state.total_salary ).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr> 

                    </tbody>

                </table>

                <br />

                <Button type="primary" onClick={this.handlePrintClick}>&nbsp;&nbsp;Print&nbsp;&nbsp;</Button>


            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        print: state.print
    }
}

export default connect( mapStatetoProps, { get_letter, get_summary } )( PaySlip );



// WEBPACK FOOTER //
// ./src/pages/prints/payslip/index.js